import {
  EarnIcon,
  FormatListBulletedIcon,
  JobsIcon,
  MarkerIcon,
  WalletIcon,
  WelcomeIcon,
} from "@braintrust/braintrust-ui-components/Icons";
import { WalletLabelWithTokenAmount } from "@js/apps/common/components/wallet-label-with-btrust-amount";

import type { DashboardNavItem } from "../types";

export const getFreelancerNavMenuItems = ({
  jobsPath,
  myWorkMainPath,
  isNodeStaff,
}: {
  jobsPath: string;
  myWorkMainPath: string;
  isNodeStaff: boolean;
}): DashboardNavItem[] => {
  return [
    createNavItem({
      path: "/talent/dashboard/welcome/",
      ...FREELANCER_NAV_ITEMS.HOME,
    }),
    createNavItem({
      path: jobsPath,
      getIsActive: ({ pathname }) =>
        pathname.startsWith(`/jobs`) || pathname.startsWith("/role-jobs"),
      ...FREELANCER_NAV_ITEMS.JOBS,
    }),
    createNavItem({
      path: myWorkMainPath,
      getIsActive: ({ pathname }) =>
        pathname.startsWith(`/talent/dashboard/my_jobs`),
      ...FREELANCER_NAV_ITEMS.MY_WORK,
    }),
    createNavItem({
      path: "/talent/dashboard/my_wallet/",
      ...FREELANCER_NAV_ITEMS.WALLET,
    }),
    createNavItem({
      path: "/talent/dashboard/earn/",
      ...FREELANCER_NAV_ITEMS.EARN,
    }),
    createNavItem({
      path: "/rosters/",
      canAccess: isNodeStaff,
      ...FREELANCER_NAV_ITEMS.ROSTERS,
    }),
  ];
};

export const createNavItem = (arg: DashboardNavItem): DashboardNavItem => {
  return {
    icon: undefined,
    canAccess: true,
    defaultExpanded: false,
    ...arg,
    subLinks: (arg.subLinks || []).map((link) => {
      return createNavItem({
        ...link,
        path: `${link.distinctPathFromParent ? "" : arg.path + "/"}${link.path}`,
      });
    }),
  };
};

export const FREELANCER_NAV_ITEMS = {
  HOME: {
    label: "Home",
    icon: WelcomeIcon,
  },
  JOBS: {
    label: "Jobs",
    icon: JobsIcon,
  },
  MY_WORK: {
    label: "My work",
    icon: MarkerIcon,
  },
  WALLET: {
    label: <WalletLabelWithTokenAmount />,
    icon: WalletIcon,
  },
  EARN: {
    label: "Refer and Earn",
    icon: EarnIcon,
  },
  ROSTERS: {
    label: "Rosters",
    icon: FormatListBulletedIcon,
  },
};

export const FREELANCER_DASHBOARD_NAV_ITEMS = [
  createNavItem({
    path: "/talent/dashboard/my_jobs",
    ...FREELANCER_NAV_ITEMS.MY_WORK,
    subLinks: [
      {
        path: "invites",
        label: "Invites",
      },
      {
        path: "my_proposals",
        label: "Applications",
      },
      {
        path: "offers",
        label: "Job Offers",
      },
      {
        path: "history",
        label: "My Jobs",
      },
      {
        path: "invoices",
        label: "Invoices",
      },
    ],
  }),
];
